import React from 'react';
import Logo from './Logo/Logo';
import Navigation from './Navigation/Navigation';
import UserActions from './UserActions/UserActions';
import { motion } from 'framer-motion';

import MobileNavigation from './MobileNavigation/MobileNavigation';

interface HeaderProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

const Header: React.FC<HeaderProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="sticky top-0 z-50 flex items-center justify-between whitespace-nowrap border-b border-solid border-gray-200 dark:border-gray-700/50 glass-effect px-6 lg:px-10 py-3 shadow-sm"
    >
      <div className="flex items-center gap-4">
        <Logo />
        <Navigation />
      </div>
      <div className="flex items-center gap-3">
        <UserActions darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
        <MobileNavigation />
      </div>
    </motion.header>
  );
};

export default Header;